// @ts-check
/* eslint-env browser */

import { reactiveStore } from '../../reactive-store.js'

/**
 * Handles click-to-select for server-rendered map overlay items,
 * matching the pattern used by entity-list-item for extracted features.
 */
export class MapOverlayItem extends HTMLElement {
  connectedCallback () {
    this.addEventListener('click', this.#handleClick)
    this.addEventListener('submit', this.#handleFormSubmit)
  }

  /** @param {SubmitEvent} evt */
  #handleFormSubmit = async (evt) => {
    const form = evt.target
    if (!(form instanceof HTMLFormElement) || !form.dataset.mapId || !form.dataset.jobId) {
      return
    }

    evt.preventDefault()

    try {
      const response = await fetch(
        `/extractions/${form.dataset.jobId}/map/${form.dataset.mapId}/evaluate`,
        { method: 'POST' }
      )
      if (!response.ok) throw new Error('Failed to save')

      const details = form.closest('details')
      const tag = details?.querySelector('status-tag')
      if (tag) {
        tag.setAttribute('data-complete', 'true')
      }
      details?.removeAttribute('open')
      details?.focus()
    } catch (error) {
      alert('Failed to mark map as complete. Please try again.')
    }
  }

  /** @param {MouseEvent} evt */
  #handleClick = (evt) => {
    const target = evt.target
    if (!(target instanceof HTMLElement)) return

    const formElements = ['LABEL', 'INPUT', 'TEXTAREA', 'BUTTON', 'SELECT']
    if (formElements.includes(target.tagName) || target.closest('form')) return
    if (target.closest('opacity-slider') || target.closest('move-with-toggle')) return

    const details = this.querySelector('details[data-entity-id]')
    const entityId = details?.getAttribute('data-entity-id')
    if (entityId) reactiveStore.selectedFeatureId.set(entityId)
  }
}

customElements.define('map-overlay-item', MapOverlayItem)
